require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-good-weekend-m-residence.json") })
        }
      }, "path---journal-good-weekend-m-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-good-weekend-m-residence!./.cache/json/journal-good-weekend-m-residence.json
// module id = 489
// module chunks = 231608221292675